export default __webpack_public_path__ + "3923484ad41ed2bc7a225cf10fbe093b.png";